<template>
  <div class="bg-white-100 min-h-screen">
    <div class="max-h-[600px] overflow-y-auto flex flex-wrap gap-6 p-6">
      <div
        v-for="(video, index) in videos"
        :key="index"
        class="w-[17.9rem] bg-white rounded-xl shadow hover:shadow-lg transition overflow-hidden relative"
        @click="video.paidStatus ? playVidio(video) : openModal(video)"
      >
        <div class="relative cursor-pointer">
          <img
            :src="video.wrapperUrl"
            class="w-full h-40 object-cover"
            alt="wrapperUrl"
          />
          <div class="absolute inset-0 flex items-center justify-center">
            <div
              class="bg-black bg-opacity-60 text-white text-base px-4 py-2 rounded"
              v-if="!video.paidStatus"
            >
              {{ video.price }} so'm
            </div>
            <div
              class="bg-black bg-opacity-60 text-white text-base px-4 py-2 rounded"
              v-if="video.paidStatus"
            >
              <i class="fa-solid fa-play"></i>
            </div>
          </div>
        </div>
        <div
          v-if="isSubmitting"
          class="fixed inset-0 bg-black bg-opacity-30 z-50 flex items-center justify-center"
        >
          <div class="flex flex-col items-center">
            <svg
              class="animate-spin h-8 w-8 text-indigo-600 mb-2"
              xmlns="http://www.w3.org/2000/svg"
              fill="none"
              viewBox="0 0 24 24"
            >
              <circle
                class="opacity-25"
                cx="12"
                cy="12"
                r="10"
                stroke="currentColor"
                stroke-width="4"
              ></circle>
              <path
                class="opacity-75"
                fill="currentColor"
                d="M4 12a8 8 0 018-8v8H4z"
              ></path>
            </svg>
            <p class="text-blue-500 text-sm">Yuklanmoqda...</p>
          </div>
        </div>

        <!-- Text block -->
        <div class="p-4 space-y-1">
          <div class="flex justify-between items-center relative">
            <h3 class="text-sm font-semibold text-gray-900">
              {{ video.title }}
            </h3>
            <!--            <div-->
            <!--              class="text-gray-800 text-2xl font-bold cursor-pointer"-->
            <!--              @click.stop="toggleMenu(index)"-->
            <!--            >-->
            <!--              &#8942;-->
            <!--              <div-->
            <!--                v-if="openMenuIndex === index"-->
            <!--                class="absolute top-0 right-0 w-40 bg-white border rounded-lg shadow-lg z-50"-->
            <!--                style="transform: translateY(-45%)"-->
            <!--              >-->
            <!--                <ul class="text-sm text-gray-700">-->
            <!--                  <li-->
            <!--                    class="flex items-center px-4 py-2 hover:bg-gray-100 cursor-pointer"-->
            <!--                  >-->
            <!--                    <img-->
            <!--                      src="@/assets/image/playlist-dropdown.png"-->
            <!--                      alt=""-->
            <!--                      class="mr-1"-->
            <!--                    />-->
            <!--                    <span>В плейлист</span>-->
            <!--                  </li>-->
            <!--                  <li-->
            <!--                    class="flex items-center px-4 py-2 hover:bg-gray-100 cursor-pointer"-->
            <!--                  >-->
            <!--                    <img-->
            <!--                      src="@/assets/image/playlist.png"-->
            <!--                      alt=""-->
            <!--                      class="mr-1"-->
            <!--                    />-->
            <!--                    <span>В очередь</span>-->
            <!--                  </li>-->
            <!--                  <li-->
            <!--                    class="flex items-center px-4 py-2 hover:bg-gray-100 cursor-pointer"-->
            <!--                  >-->
            <!--                    <img-->
            <!--                      src="@/assets/image/clarity_share-line.png"-->
            <!--                      alt=""-->
            <!--                      class="mr-1"-->
            <!--                    />-->
            <!--                    <span>Поделиться</span>-->
            <!--                  </li>-->
            <!--                </ul>-->
            <!--              </div>-->
            <!--            </div>-->
          </div>

          <p class="text-xs text-gray-500">{{ video.orgName }}</p>
          <!--          <p class="text-xs text-gray-400">-->
          <!--            {{ video.time }} · {{ 0 }} просмотров · {{ 0 }} комм.-->
          <!--          </p>-->
        </div>
      </div>
      <div
        class="fixed inset-0 bg-black bg-opacity-20 flex items-center justify-center z-50"
        v-if="showModal"
        @click.self="closeModal"
      >
        <div class="bg-white rounded-xl w-[90%] max-w-md shadow-lg">
          <div class="p-5">
            <h2 class="text-xl font-medium mb-4 text-center">To‘lov oynasi</h2>

            <div class="flex flex-col items-center mb-5">
              <div class="w-1/3 mr-3">
                <img
                  :src="selectedCard.wrapperUrl"
                  alt="wrapperUrl"
                  class="rounded-lg w-full h-full object-cover"
                />
              </div>
              <div class="w-2/3 text-center">
                <p class="font-semibold text-sm">{{ selectedCard.title }}</p>
                <p class="text-gray-500 text-xs">
                  {{ selectedCard.orgName }}
                </p>
              </div>
            </div>

            <div class="flex items-center flex-col mb-5">
              <p>To‘lanadigan summa:</p>
              <p class="text-2xl font-bold text-blue-600 text-center">
                {{ selectedCard.price.toLocaleString("ru-RU") }} so'm
              </p>
            </div>

            <div class="mb-5">
              <p class="text-sm text-gray-600 mb-2 text-center">
                Karta raqami orqali pul o‘tkazing:
              </p>
              <div
                class="text-center relative flex items-center justify-center font-bold"
              >
                <span class="mr-2">
                  {{ formatCardNumber(selectedCard.paymentCardNumber) }}
                </span>
                <button
                  class="text-blue-600 ml-2"
                  @click="
                    copyToClipboard(selectedCard.paymentCardNumber, 'card')
                  "
                  title="Копировать номер карты"
                >
                  <img
                    src="@/assets/image/copy_button.png"
                    alt=""
                    class="h-5 w-5"
                  />
                  <span
                    v-if="copied.card"
                    class="absolute -top-8 right-0 bg-gray-800 text-white text-xs px-2 py-1 rounded"
                  >
                    Nusxa olindi
                  </span>
                </button>
              </div>
            </div>

            <div class="mb-5">
              <p class="text-sm text-gray-600 mb-2 text-center">
                Tez orada quyidagi to‘lov usullari mavjud bo‘ladi
              </p>
              <div class="flex justify-between gap-3">
                <button
                  class="bg-gray-50 rounded-xl py-2 px-4 w-full flex items-center justify-center"
                >
                  <img src="@/assets/image/payme_button.png" alt="PayME" />
                </button>
                <button
                  class="bg-gray-50 rounded-xl py-2 px-4 w-full flex items-center justify-center"
                >
                  <img src="@/assets/image/click_button.png" alt="Click" />
                </button>
              </div>
            </div>
            <div
              class="border border-dashed border-gray-300 rounded-lg p-[4px] cursor-pointer text-center mb-4"
              @click="triggerCoverInput"
            >
              <div v-if="coverFileName">
                <span>{{ coverFileName }}</span>
              </div>
              <div v-else>
                <img
                  src="@/assets/image/image-upload.png"
                  class="h-6 w-6 mt-2 mx-auto"
                  alt="Upload"
                />
                <h3 class="text-base font-medium">To'lov cheki</h3>
                <input
                  ref="coverInput"
                  type="file"
                  class="hidden"
                  @change="onCoverSelected"
                  accept="image/*"
                />
              </div>
            </div>

            <button
              @click="submitPaymentCheck"
              class="w-full bg-blue-600 text-white py-3 rounded-lg hover:bg-blue-700 font-medium"
            >
              Chekni yuklash
            </button>
          </div>
        </div>
      </div>
    </div>
  </div>
</template>

<script>
import http from "@/http";
import { ElMessage } from "element-plus";

export default {
  data() {
    return {
      isSubmitting: false,
      coverFile: null,
      coverFileName: null,
      videos: [
        // {
        //   wrapperUrl: "/img/test.c92764e2.jpg",
        //   price: 8900,
        //   title: "Наративные связи",
        //   orgName: "Зубы-сессия",
        //   time: "2 дня",
        //   views: "12k",
        //   comments: "24k",
        //   paidStatus: false,
        //   id: "3935ea79-2181-4191-b3bd-7705ff533d3d",
        // },
        // {
        //   wrapperUrl: "/img/test.c92764e2.jpg",
        //   price: 8900,
        //   title: "Наративные связи",
        //   orgName: "Зубы-сессия",
        //   time: "2 дня",
        //   views: "12k",
        //   comments: "24k",
        //   id: "3935ea79-2181-4191-b3bd-7705ff533d3d",
        //   paidStatus: true,
        // },
        // {
        //   wrapperUrl: "/img/test.c92764e2.jpg",
        //   price: 8900,
        //   title: "Наративные связи",
        //   orgName: "Зубы-сессия",
        //   time: "2 дня",
        //   views: "12k",
        //   comments: "24k",
        //   id: "3935ea79-2181-4191-b3bd-7705ff533d3d",
        //   paidStatus: false,
        // },
        // {
        //   wrapperUrl: "/img/test.c92764e2.jpg",
        //   price: 8900,
        //   title: "Наративные связи",
        //   orgName: "Зубы-сессия",
        //   time: "2 дня",
        //   views: "12k",
        //   comments: "24k",
        //   id: "3935ea79-2181-4191-b3bd-7705ff533d3d",
        //   paidStatus: false,
        // },
      ],
      showModal: false,
      selectedCard: {
        paymentCardNumber: "",
        price: 0,
        wrapperUrl: "",
        title: "",
        orgName: "",
      },
      copied: {
        card: false,
      },
    };
  },
  mounted() {
    this.getVideoList();
  },
  methods: {
    playVidio(video) {
      this.$router.push(`/main/watch-video?videoId=${video.id}`);
    },
    convertFileToBase64(file) {
      return new Promise((resolve, reject) => {
        const reader = new FileReader();
        reader.onload = () => resolve(reader.result);
        reader.onerror = (error) => reject(error);
        reader.readAsDataURL(file);
      });
    },
    async submitPaymentCheck() {
      if (!this.coverFile) {
        ElMessage({
          type: "error",
          message: "Iltimos, to‘lov chekini kiriting",
        });
        return;
      }
      this.isSubmitting = true;
      try {
        const base64Data = await this.convertFileToBase64(this.coverFile);
        const payload = {
          videoId: this.selectedCard.videoId || this.selectedCard.id,
          file: {
            fileName: this.coverFile.name,
            fileData: base64Data.split(",")[1],
          },
        };

        await http.post("/payment/video", payload);
        ElMessage({
          type: "success",
          message: "To‘lov cheki muvaffaqiyatli yuborildi.",
        });
        this.closeModal();
        window.location.reload();
      } catch (error) {
        ElMessage({
          type: "error",
          message: "Xatolik yuz berdi. Qayta urinib ko‘ring.",
        });
      } finally {
        this.isSubmitting = false;
      }
    },
    formatCardNumber(number) {
      return String(number).replace(/(\d{4})(?=\d)/g, "$1 ");
    },
    triggerCoverInput() {
      this.$refs.coverInput?.click();
    },
    onCoverSelected(event) {
      const file = event.target.files[0];
      if (file) {
        this.coverFile = file;
        this.coverFileName = file.name;
      }
    },
    async copyToClipboard(text, type) {
      try {
        await navigator.clipboard.writeText(text);
        this.copied[type] = true;
        setTimeout(() => (this.copied[type] = false), 2000);
      } catch (err) {
        console.error("Nusxa olishda xatolik:", err);
      }
    },
    async getVideoList() {
      this.isSubmitting = true;
      try {
        const userInfo = JSON.parse(localStorage.getItem("user_info"));
        let url = "video/confirmed-videos";
        if (userInfo?.orgId) {
          url += `?orgId=${userInfo.orgId}`;
        }
        const response = await http.post(url, {});
        this.videos = response.data.data.content;
      } catch (error) {
        console.error("Video olishda xatolik:", error);
      } finally {
        this.isSubmitting = false;
      }
    },
    async openModal(video) {
      try {
        const response = await http.get(
          `/video/payment-info?videoId=${video.id}`
        );
        this.selectedCard = response.data.data;
        this.showModal = true;
      } catch (error) {
        console.error("To‘lov ma'lumotini olishda xatolik:", error);
      }
    },
    closeModal() {
      this.showModal = false;
    },
  },
};
</script>

<style scoped></style>
